import { connect, ConnectedProps } from 'react-redux';

import { productFeatureDisabled } from 'dashboard/lib/productFeature';
import { ProductFeatureName } from 'dashboard/models/organization';
import { RootState } from 'dashboard/redux/store';
import DashboardCaseAnalyticsView from 'dashboard/views/DashboardCaseAnalyticsView';

const DashboardCaseAnalyticsRoute = ({ currentEnvironment, organization }: PropsFromRedux) => {
  const hasCasesBasic = !productFeatureDisabled(
    organization,
    ProductFeatureName.CasesBasic,
    currentEnvironment.type,
  );
  const hasCasesEnhanced = !productFeatureDisabled(
    organization,
    ProductFeatureName.CasesEnhanced,
    currentEnvironment.type,
  );
  const hasCasesEnterprise = !productFeatureDisabled(
    organization,
    ProductFeatureName.CasesEnterprise,
    currentEnvironment.type,
  );

  return (
    <DashboardCaseAnalyticsView
      currentEnvironment={currentEnvironment}
      organization={organization}
      hasCasesBasic={hasCasesBasic}
      hasCasesEnhanced={hasCasesEnhanced}
      hasCasesEnterprise={hasCasesEnterprise}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  currentEnvironment: state.currentEnvironment.currentEnvironment,
  organization: state.organization.organization,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardCaseAnalyticsRoute);
